// extracted by mini-css-extract-plugin
export const belowTheFold = "homepage-btf-module--below-the-fold--3P2AY";
export const accentBlock = "homepage-btf-module--accent-block--2B1QN";
export const imageTrio = "homepage-btf-module--image-trio--3cUWx";
export const imageWrapper = "homepage-btf-module--image-wrapper--16xAs";
export const overlay = "homepage-btf-module--overlay--3YHe0";